import React from "react";
import { Link } from "react-router-dom";

const ScholarshipEventsBanner = () => {
  return (
    <div className="w-full lg:min-h-[657px] bg-gradient-to-b from-[#EDFCFF] to-[#89C9ED] max-md:pb-5 ">
      <div className="container mx-auto flex max-md:flex-col-reverse md:flex-row justify-between ">
        <div className="flex flex-col md:w-3/5 gap-3">
          <div
            className="rounded-[10px] max-md:mt-[-14%] bg-white shadow-[3px_3px_15px_0px_rgba(0,0,0,0.15)] xl:mt-32 min-max-md:mt-12 md:h-[232px] max-md:h-auto max-md:w-full w-full max-w-[562.538px]"
            style={{ flexShrink: 0 }}
          >
            <img
              src="/images/scholarship-events-banner1.webp"
              alt="College Mentor Scholarship 2025"
              className="w-full md:h-full object-contain"
            />
          </div>
          <span className="text-[#173CBA]  text-[24px] md:font-medium leading-[36px] max-md:text-center max-md:font-normal">
            Meet representatives from top{" "}
            <span className="max-md:font-bold">Universities</span>
          </span>
          <span className="text-[#173CBA] flex flex-col max-md:font-bold  text-[24px] md:font-bold leading-[32px] mt-2 max-md:text-center ">
            On May 12, 2025 - 10 AM to 6 PM A Plus Convention Center
            <span className="max-md:font-normal">
              Vijayawada Andhra Pradesh
            </span>
          </span>
          <div className="flex max-md:justify-center">
            <Link
              to={"/events/college-mentor-scholarship/register"}
              className="bg-[#0C9]  text-white text-[16px] font-semibold px-6 py-3 rounded justify-center flex"
            >
              Register now
            </Link>
          </div>
          <div className="flex gap-[11px] max-md:flex-col min-max-md:text-[12px] min-max-md:pb-6 text-base ">
            {/* <Link
              to={"/college-mentor-scholarship/event/universities"}
              className="bg-[#173CBA] max-md:w-fit max-md:mx-auto flex flex-row max-md:justify-center items-center justify-between gap-2 text-white px-6 py-2 rounded"
            >
              For Colleges & Universities
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
              >
                <path
                  d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6L1 6.75L14 6.75L14 6L14 5.25L1 5.25L1 6Z"
                  fill="white"
                />
              </svg>
            </Link> */}
            {/* <Link
              to={"/events/college-mentor-scholarship/register"}
              className="bg-[#173CBA] flex max-md:w-fit max-md:mx-auto flex-row max-md:justify-center justify-between gap-2 items-center  text-white px-6 py-2 rounded"
            >
              For Students & Parents
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
              >
                <path
                  d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6L1 6.75L14 6.75L14 6L14 5.25L1 5.25L1 6Z"
                  fill="white"
                />
              </svg>
            </Link> */}
          </div>
        </div>
        <div className="flex md:w-2/5 max-sm:justify-center max-md:w-[95%] max-md:mx-auto">
          <img
            src="/images/scholarship-events-banner.webp"
            alt="Graduated student"
            className="w-full "
          />
        </div>
      </div>
    </div>
  );
};

export default ScholarshipEventsBanner;
